import { useTranslation } from 'react-i18next';

import { useDownloadObject } from '@widgets/Files/hooks/useDownloadObject';
import { TFolderId } from '@widgets/Files/model/types/folderId.type';
import { useFileFolder } from '@widgets/Files/UI/FileFolder/useFileFolder';

export const useFolderDropdown = (folderId: TFolderId) => {
    const { t } = useTranslation();
    const { onChangeModalMode, onChangeCurrentFolderInDropdown } = useFileFolder(folderId);
    const downloadMutation = useDownloadObject(folderId);

    const onDownloadObjHandler = () => {
        downloadMutation.mutate();
    };
    return {
        t,
        onChangeCurrentFolderInDropdown,
        onChangeModalMode,
        onDownloadObjHandler,
    };
};
